import { Text } from "./Text";

/** Preserve the complete evidence hash without forcing narrow pages wider. */
export function DocumentHash({ label, value }: { label: string; value: string | null | undefined }) {
  return <div className="v365-document-hash"><Text variant="caption" tone="secondary">{label}: {value ?? "Not generated"}</Text></div>;
}
